import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase-config";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import logo from ".././Assets/logo.png";

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignUp() {
  let navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        data.get("email"),
        data.get("password")
      );
      toast.success("User created successfully");
      navigate("/Login");
      console.log(userCredential);
    } catch (error) {
      console.error("error", error.message);
      toast.error(`Sign up failed: ${error.message}`);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img style={{ margin: "10px" }} height="80px" src={logo} alt="" />

          <Box sx={{ border: "1px solid #dddddd", borderRadius: "10px" }}>
            <Box sx={{ padding: "40px" }}>
              <Typography component="h1" variant="h5">
                Sign up
              </Typography>
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ mt: 3, width: "320px" }}
              >
                
                    <Typography sx={{ mb: "10px", color: "#949494" }}>
                      Email
                    </Typography>
                              <TextField
                                  sx={{mb:'30px'}}
                      hiddenLabel
                      required
                      fullWidth
                      id="email"
                      placeholder="Enter email address"
                      name="email"
                      autoComplete="email"
                    />
             
                
                    <Typography sx={{ mb: "10px", color: "#949494" }}>
                      Password
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      autoComplete="new-password"
                    />
                
            
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={ { mt: 3, mb: 2 ,
                    backgroundColor: '#F2A040', borderColor: '#F2A040',boxShadow:'none', ":hover": {
                      borderColor:'#F2A040', backgroundColor: '#F2A040',color:'#ffffff', boxShadow:'none'
                    }
                  }}
                >
                  Sign Up
                </Button>
                <Grid container justifyContent="flex-start">
                  <Grid item>
                    <Link sx={{ color: "#000", textDecoration: "none" }} component={RouterLink} to="/Login" variant="body2">
                      Already have an account? <span style={{ color: "#f38500", textDecoration: "none" }} >Sign In"</span>
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
